import FlutterIdentify from "../../../../contents/docs/libraries/flutter/_snippets/identify.mdx";
import FlutterInstall from "../../../../contents/docs/integrate/_snippets/install-flutter.mdx";
import FlutterSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-flutter.mdx";
import IdentifiedVsAnonymousIntro from "../../../../contents/docs/product-analytics/_snippets/identified-vs-anonymous-intro.mdx";
import HowToCaptureAnonymousEventsFlutter from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-events-flutter.mdx";
import HowToCaptureIdentifiedEventsFlutter from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-flutter.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import FlutterFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-flutter.mdx";
import * as React from 'react';
export default {
  FlutterIdentify,
  FlutterInstall,
  FlutterSendEvents,
  IdentifiedVsAnonymousIntro,
  HowToCaptureAnonymousEventsFlutter,
  HowToCaptureIdentifiedEventsFlutter,
  FeatureFlagsLibsIntro,
  FlutterFeatureFlagsCode,
  React
};